import type { HandlingUnit } from "~/shared/types/quote-details-types.ts";

function isItemFieldInvalid(item: HandlingUnit, key: string): boolean {
	switch (key) {
		case "quantity":
		case "weight":
		case "length":
		case "width":
		case "height": {
			return (
				item[key as keyof HandlingUnit] == null ||
				(item[key as keyof HandlingUnit] as number) <= 0
			);
		}
		case "class": {
			return !item.class || item.class.id === 0 || !item.class.name;
		}
		default: {
			return false;
		}
	}
}

export const VALIDATED_ITEM_FIELDS = [
	"quantity",
	"weight",
	"length",
	"width",
	"height",
	"class",
] as const;

/**
 * Validates a single commodity handling unit and returns the set of invalid
 * field keys. Shared by the Quote and Tender validation flows so the commodity
 * rules stay defined in one place.
 */
export function validateHandlingUnitItem(
	item: HandlingUnit,
	isSortAndSegregate: boolean,
): Set<string> {
	const invalidFields = new Set<string>();
	for (const key of VALIDATED_ITEM_FIELDS) {
		if (isItemFieldInvalid(item, key)) {
			invalidFields.add(key);
		}
	}
	// Piece count is only shown when Sort and Segregate is selected, but
	// when it is shown it is required.
	if (isSortAndSegregate && (item.pieceCount == null || item.pieceCount <= 0)) {
		invalidFields.add("pieceCount");
	}
	return invalidFields;
}
